/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ViewChild, ViewContainerRef, Renderer2, inject, signal, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ScriptService } from '@/app/services/script/script.service';
import { LoginService } from '@/app/services/login.service';
import { CommonModule } from '@angular/common';
import { DesyAngularModule } from 'desy-angular';
import { UserAnjana } from '@/app/interfaces/UserAnjana';

@Component({
  selector: 'app-login',
  imports: [CommonModule, DesyAngularModule],
  standalone: true,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements AfterViewInit {
  @ViewChild('alertPlace', { read: ViewContainerRef }) alertPlace!: ViewContainerRef;

  private loginService = inject(LoginService);
  private router = inject(Router);
  private scriptService = inject(ScriptService);
  private renderer = inject(Renderer2);

  isSearching = signal(false);

  private urlServ = environment.url_serv;

  constructor() {
    // Vinculamos callback global
    (window as any).onIdentification = (operation: any) => this.onIdentification(operation);
  }

  ngAfterViewInit() {
    this.loadSsoScript();
  }

  private loadSsoScript(): void {
    const scriptUrl = `https://${this.urlServ}/js/sslssso.js`;
    const scriptEl = this.scriptService.loadJsScript(this.renderer, scriptUrl);

    scriptEl.onload = () => this.loadIframe();
    scriptEl.onerror = () => console.error('Error loading SSO script');
  }

  private loadIframe(): void {
    this.isSearching.set(true);
    const redirectParam = btoa(environment.home_url).replace(/\+/g, '-').replace(/\//g, '_');
    const iframeUrl = `https://${this.urlServ}/rest/identification/HAL/${redirectParam}`;

    const iframe = document.getElementById('mfe_iframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.src = iframeUrl;
      iframe.scrolling = 'no';
    }
    this.isSearching.set(false);
  }

  private async onIdentification(operation: any): Promise<void> {
    try {
      this.isSearching.set(true);

      if (!operation?.jwt || !operation?.eIdentifier) {
        console.error('Invalid identification response');
        return;
      }

      // Body que envías al backend
      const body = {
        nif: operation.eIdentifier,
        org: operation.organismCode,
        token: operation.jwt,
      };

      // El backend guarda token en httpOnly cookie y devuelve info del usuario
      const userData: UserAnjana = await this.loginService.validateToken(body);

      if (!userData) {
        console.error('User validation failed');
        this.loadIframe();
        return;
      }

      this.loginService.setUserData({
        givenName: userData.givenName,
        surname1: userData.surname1,
        surname2: userData.surname2,
        roleCode: userData.roleCode,
        identificationMethod: userData.identificationMethod,
        orgCode: body.org,
        orgName: userData.organismName,
        stationWork: userData.puesto,
        email: userData.email,
        department: userData.departamento,
        rpt: userData.rpt,
        roles: userData.roles,
        nif: userData.eIdentifier,
        serviceName: userData.servicio,
        generalDirectorateCode: userData.codigo_direccion_general,
      });
      const loginTime = Date.now();
      localStorage.setItem('loginTime', loginTime.toString());
      await this.router.navigate(['/inicio']);
    } catch (err) {
      console.error('Error during identification', err);
      this.loadIframe();
    } finally {
      this.isSearching.set(false);
    }
  }
}
